/*
 *
 *  actions
 *
 */

import {
  //LOAD_VIDEO_TEAM
  LOAD_SALES_RETURN,
  LOAD_SALES_RETURN_SUCCESS,
  LOAD_SALES_RETURN_ERROR,
  CREATE_SALES_RETURN,
  CREATE_SALES_RETURN_SUCCESS,
  CREATE_SALES_RETURN_ERROR,
  UPDATE_SALES_RETURN,
  UPDATE_SALES_RETURN_SUCCESS,
  UPDATE_SALES_RETURN_ERROR,
  LOAD_PARTY_VENDOR_ADDRESS,
  LOAD_PARTY_VENDOR_ADDRESS_SUCCESS,
  LOAD_PARTY_VENDOR_ADDRESS_ERROR,
  CREATE_PARTY_VENDOR_ADDRESS,
  CREATE_PARTY_VENDOR_ADDRESS_SUCCESS,
  CREATE_PARTY_VENDOR_ADDRESS_ERROR,
  DELETE_SALES_RETURN,
  DELETE_SALES_RETURN_SUCCESS,
  DELETE_SALES_RETURN_ERROR,
  LOAD_SALES_RETURN_RECORDS_META_DATA,
  LOAD_SALES_RETURN_RECORDS_META_DATA_SUCCESS,
  LOAD_SALES_RETURN_RECORDS_META_DATA_ERROR,
  LOAD_PARTIES_TRANSACTION,
  LOAD_PARTIES_TRANSACTION_SUCCESS,
  LOAD_SALES_RETURN_CATEGORY,
  LOAD_SALES_RETURN_CATEGORY_SUCCESS,
  LOAD_SALES_RETURN_CATEGORY_ERROR,
  CREATE_SALES_RETURN_PARTIES_CATEGORY,
  CREATE_SALES_RETURN_PARTIES_CATEGORY_SUCCESS,
  CREATE_SALES_RETURN_PARTIES_CATEGORY_ERROR,
  LOAD_PARTIES_TRANSACTION_ERROR,
  LOAD_SALES_RETURN_DASHBOARD_TRANSACTION,
  LOAD_SALES_RETURN_DASHBOARD_TRANSACTION_SUCCESS,
  LOAD_SALES_RETURN_DASHBOARD_TRANSACTION_ERROR,
  LOAD_SALES_RETURN_TOTAL,
  LOAD_SALES_RETURN_TOTAL_SUCCESS,
  LOAD_SALES_RETURN_TOTAL_ERROR,
  LOAD_RETURN_TOTAL_SALES_PAID,
  LOAD_RETURN_TOTAL_SALES_PAID_SUCCESS,
  LOAD_RETURN_TOTAL_SALES_PAID_ERROR,
  LOAD_RETURN_TOTAL_SALES_UNPAID,
  LOAD_RETURN_TOTAL_SALES_UNPAID_SUCCESS,
  LOAD_RETURN_TOTAL_SALES_UNPAID_ERROR,
  LOAD_SALES_RETURN_SEARCH_IMEI_BARCODE,
  LOAD_SALES_RETURN_SEARCH_IMEI_BARCODE_SUCCESS,
  LOAD_SALES_RETURN_SEARCH_IMEI_BARCODE_ERROR,
} from "./constants";

// load parties
export function loadSalesInvoice(salesInvoiceList) {
  return {
    type: LOAD_SALES_RETURN,
    salesInvoiceList,
  };
}

export function loadSalesInvoiceSuccess(sales_invoice_list, success) {
  return {
    type: LOAD_SALES_RETURN_SUCCESS,
    sales_invoice_list,
    success,
  };
}

export function loadSalesInvoiceError(error) {
  return {
    type: LOAD_SALES_RETURN_ERROR,
    error,
  };
}
// load parties
export function loadSearchImeiBarcodeList(salesInvoiceList) {
  return {
    type: LOAD_SALES_RETURN_SEARCH_IMEI_BARCODE,
    salesInvoiceList,
  };
}

export function loadSearchImeiBarcodeListSuccess(search_imei_barcode, success) {
  return {
    type: LOAD_SALES_RETURN_SEARCH_IMEI_BARCODE_SUCCESS,
    search_imei_barcode,
    success,
  };
}

export function loadSearchImeiBarcodeListError(error) {
  return {
    type: LOAD_SALES_RETURN_SEARCH_IMEI_BARCODE_ERROR,
    error,
  };
}

// load parties
export function loadDashboardTransactions(transactionsList) {
  return {
    type: LOAD_SALES_RETURN_DASHBOARD_TRANSACTION,
    transactionsList,
  };
}

export function loadDashboardTransactionsSuccess(
  dashboard_transactions,
  success
) {
  return {
    type: LOAD_SALES_RETURN_DASHBOARD_TRANSACTION_SUCCESS,
    dashboard_transactions,
    success,
  };
}

export function loadDashboardTransactionsError(error) {
  return {
    type: LOAD_SALES_RETURN_DASHBOARD_TRANSACTION_ERROR,
    error,
  };
}

// load total balance
export function loadSalesTotal(transactionsList) {
  return {
    type: LOAD_SALES_RETURN_TOTAL,
    transactionsList,
  };
}

export function loadSalesTotalSuccess(sales_total_list, success) {
  return {
    type: LOAD_SALES_RETURN_TOTAL_SUCCESS,
    sales_total_list,
    success,
  };
}

export function loadSalesTotalError(error) {
  return {
    type: LOAD_SALES_RETURN_TOTAL_ERROR,
    error,
  };
}

// load total balance
export function loadTotalPaid(transactionsList) {
  return {
    type: LOAD_RETURN_TOTAL_SALES_PAID,
    transactionsList,
  };
}

export function loadTotalPaidSuccess(total_paid_list, success) {
  return {
    type: LOAD_RETURN_TOTAL_SALES_PAID_SUCCESS,
    total_paid_list,
    success,
  };
}

export function loadTotalPaidError(error) {
  return {
    type: LOAD_RETURN_TOTAL_SALES_PAID_ERROR,
    error,
  };
}

// load total balance
export function loadTotalUnPaid(transactionsList) {
  return {
    type: LOAD_RETURN_TOTAL_SALES_UNPAID,
    transactionsList,
  };
}

export function loadTotalUnPaidSuccess(total_unpaid_list, success) {
  return {
    type: LOAD_RETURN_TOTAL_SALES_UNPAID_SUCCESS,
    total_unpaid_list,
    success,
  };
}

export function loadTotalUnPaidError(error) {
  return {
    type: LOAD_RETURN_TOTAL_SALES_UNPAID_ERROR,
    error,
  };
}

// load pary address
export function loadPartyVendorAddress(salesInvoiceList) {
  return {
    type: LOAD_PARTY_VENDOR_ADDRESS,
    salesInvoiceList,
  };
}

export function loadPartyVendorAddressSuccess(party_address_list, success) {
  return {
    type: LOAD_PARTY_VENDOR_ADDRESS_SUCCESS,
    party_address_list,
    success,
  };
}

export function loadPartyVendorAddressError(error) {
  return {
    type: LOAD_PARTY_VENDOR_ADDRESS_ERROR,
    error,
  };
}

// Category

export function loadPartiesCategory(categoryList) {
  return {
    type: LOAD_SALES_RETURN_CATEGORY,
    categoryList,
  };
}

export function loadPartiesCategorySuccess(category_list, success) {
  return {
    type: LOAD_SALES_RETURN_CATEGORY_SUCCESS,
    category_list,
    success,
  };
}

export function loadPartiesCategoryError(error) {
  return {
    type: LOAD_SALES_RETURN_CATEGORY_ERROR,
    error,
  };
}

//category list
export function createPartiesCategoryList(categoryList) {
  return {
    type: CREATE_SALES_RETURN_PARTIES_CATEGORY,
    categoryList,
  };
}

export function createPartiesCategoryListSuccess(categoryList, success) {
  return {
    type: CREATE_SALES_RETURN_PARTIES_CATEGORY_SUCCESS,
    categoryList,
    success,
  };
}

export function createPartiesCategoryListError(error) {
  return {
    type: CREATE_SALES_RETURN_PARTIES_CATEGORY_ERROR,
    error,
  };
}

// party address create
export function createPartyVendorAddress(partyAddress) {
  return {
    type: CREATE_PARTY_VENDOR_ADDRESS,
    partyAddress,
  };
}

export function createPartyVendorAddressSuccess(partyAddress, success) {
  return {
    type: CREATE_PARTY_VENDOR_ADDRESS_SUCCESS,
    partyAddress,
    success,
  };
}

export function createPartyVendorAddressError(error) {
  return {
    type: CREATE_PARTY_VENDOR_ADDRESS_ERROR,
    error,
  };
}

// load parties
export function createSalesInvoiceList(salesInvoiceList) {
  return {
    type: CREATE_SALES_RETURN,
    salesInvoiceList,
  };
}

export function createSalesInvoiceListSuccess(salesInvoiceList, success) {
  return {
    type: CREATE_SALES_RETURN_SUCCESS,
    salesInvoiceList,
    success,
  };
}

export function createSalesInvoiceListError(error) {
  return {
    type: CREATE_SALES_RETURN_ERROR,
    error,
  };
}
// load parties
export function updateSalesInvoiceList(salesInvoiceList) {
  return {
    type: UPDATE_SALES_RETURN,
    salesInvoiceList,
  };
}

export function updateSalesInvoiceListSuccess(salesInvoiceList, success) {
  return {
    type: UPDATE_SALES_RETURN_SUCCESS,
    salesInvoiceList,
    success,
  };
}

export function updateSalesInvoiceListError(error) {
  return {
    type: UPDATE_SALES_RETURN_ERROR,
    error,
  };
}
// load parties
export function deleteSalesInvoiceList(salesInvoiceList) {
  return {
    type: DELETE_SALES_RETURN,
    salesInvoiceList,
  };
}

export function deleteSalesInvoiceListSuccess(salesInvoiceList, success) {
  return {
    type: DELETE_SALES_RETURN_SUCCESS,
    salesInvoiceList,
    success,
  };
}

export function deleteSalesInvoiceListError(error) {
  return {
    type: DELETE_SALES_RETURN_ERROR,
    error,
  };
}

// load parties transaction
export function loadPartiesTransaction(salesInvoiceList) {
  return {
    type: LOAD_PARTIES_TRANSACTION,
    salesInvoiceList,
  };
}

export function loadPartiesTransactionSuccess(
  parties_transaction_list,
  success
) {
  return {
    type: LOAD_PARTIES_TRANSACTION_SUCCESS,
    parties_transaction_list,
    success,
  };
}

export function loadPartiesTransactionError(error) {
  return {
    type: LOAD_PARTIES_TRANSACTION_ERROR,
    error,
  };
}

export function loadSalesInvoiceRecordsMetaData() {
  return {
    type: LOAD_SALES_RETURN_RECORDS_META_DATA,
  };
}

/**
 *
 * @param {object} recordsMetaData
 * @returns
 */
export function loadSalesInvoiceRecordsMetaDataSuccess(recordsMetaData) {
  return {
    type: LOAD_SALES_RETURN_RECORDS_META_DATA_SUCCESS,
    recordsMetaData,
  };
}

/**
 *
 * @param {string} error
 * @returns
 */
export function loadSalesInvoiceRecordsMetaDataError(error) {
  return {
    type: LOAD_SALES_RETURN_RECORDS_META_DATA_ERROR,
    error,
  };
}

const actions = {
  loadSalesInvoice,
  loadSalesInvoiceSuccess,
  loadSalesInvoiceError,

  loadDashboardTransactions,
  loadDashboardTransactionsSuccess,
  loadDashboardTransactionsError,

  loadSalesTotal,
  loadSalesTotalSuccess,
  loadSalesTotalError,
  loadTotalPaid,
  loadTotalPaidSuccess,
  loadTotalPaidError,
  loadTotalUnPaid,
  loadTotalUnPaidSuccess,
  loadTotalUnPaidError,

  loadPartyVendorAddress,
  loadPartyVendorAddressSuccess,
  loadPartyVendorAddressError,

  loadPartiesCategory,
  loadPartiesCategorySuccess,
  loadPartiesCategoryError,

  createPartiesCategoryList,
  createPartiesCategoryListSuccess,
  createPartiesCategoryListError,

  loadPartiesTransaction,
  loadPartiesTransactionSuccess,
  loadPartiesTransactionError,

  createSalesInvoiceList,
  createSalesInvoiceListSuccess,
  createSalesInvoiceListError,

  createPartyVendorAddress,
  createPartyVendorAddressSuccess,
  createPartyVendorAddressError,

  updateSalesInvoiceList,
  updateSalesInvoiceListSuccess,
  updateSalesInvoiceListError,

  deleteSalesInvoiceList,
  deleteSalesInvoiceListSuccess,
  deleteSalesInvoiceListError,

  loadSalesInvoiceRecordsMetaData,
  loadSalesInvoiceRecordsMetaDataSuccess,
  loadSalesInvoiceRecordsMetaDataError,
  loadSearchImeiBarcodeList,
  loadSearchImeiBarcodeListSuccess,
  loadSearchImeiBarcodeListError,
};

export default actions;
